import { useEffect, useState } from 'react'
import { leftShoppingLink, AllProducts } from '../../../constants/index'
import ShoppingCard from './ShoppingCard'
import close from "../../../img/close.svg";
import menu from '../../../img/menu.svg'
import { Dialog } from '@headlessui/react';
import { useGetNotesQuery } from '../../../features/notes/notesApiSlice';
import { Link } from 'react-router-dom';
import { content_mod_final } from './ShoppingCard'
import productDetails from './productDetails.js'
import nutritionFact from './nutritionFact.png'



const navLinks = []

const ShopOnline = () => {

    const [isColor, setIsColor] = useState(false)
    const [isMiniColor, setIsMiniColor] = useState(false)
    const [isSize, setIsSize] = useState(false)
    const [isMiniSize, setIsMiniSize] = useState(false)
    const [isMiniSortBy, setisMiniSortBy] = useState(true)
    const [isFilter, setIsFilter] = useState(false)
    const [selectedFiler, setSelectedFiler] = useState("")
    const [openDetails, setOpenDetails]= useState(false)
    const [detailsProduct,setDetailsProduct]= useState("") 
    const [detailsProductImage, setDetailsProductImage]=useState("")

    const[openIngrident,  setOpenIngrident]=useState(false);


    const {
        data: notes,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetNotesQuery('notesList', {
        pollingInterval: 60000,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    const nutriionFactConmponent=
                  

                // <div class="bg-neutral-primary-soft w-full block h-full p-6 border border-default rounded-base shadow-xs aspect-video object-cover overflow-hidden group-hover:scale-105 transition-all">
                //     <h5 class="mb-3 text-2xl font-semibold tracking-tight text-heading leading-8">Noteworthy technology acquisitions 2021</h5>
                //     <p class="text-body mb-6">Here are the biggest technology acquisitions of 2025 so far, in reverse chronological order.</p>
                //     <a href="#" class="inline-flex items-center text-white bg-brand box-border border border-transparent hover:bg-brand-strong focus:ring-4 focus:ring-brand-medium shadow-xs font-medium leading-5 rounded-base text-sm px-4 py-2.5 focus:outline-none">
                //         Read more
                //         <svg class="w-4 h-4 ms-1.5 rtl:rotate-180 -me-0.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4"/></svg>
                //     </a>
                // </div>

                // <!-- component -->
                    // <!-- https://www.fda.gov/food/food-labeling-nutrition/changes-nutrition-facts-label -->
                    <div className='w-full aspect-video object-cover overflow-hidden group-hover:scale-105 transition-all overflow-y-auto'> 
                        <div class="p-1 border-2 border-black font-sans mx-auto items-center">
                            <div class=" text-sm lg:text-4xl font-extrabold leading-none">Nutrition Facts</div>
                            <div class="leading-snug">8 servings per container</div>
                            <div class="flex justify-between font-bold border-b-8 border-black">
                                <div>Serving size</div><div>2/3 cup (55g)</div>
                            </div>
                            <div class="flex justify-between items-end font-extrabold">
                                <div>
                                    <div class="font-bold">Amount per serving</div>
                                    <div class="text-4xl">Calories</div>
                                </div>
                                {/* <div class="text-5xl">45</div> */}
                                <div class="text-5xl">{detailsProduct.nutritionFact?detailsProduct.nutritionFact.totalCarbohydrates:45}</div>
                            </div>
                            <div class="border-t-4 border-black text-sm pb-1">
                                <div class="text-right font-bold pt-1 pb-1">% Daily value*</div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div>
                                        <span class="font-bold">Total Fat</span>{": "}{detailsProduct.nutritionFact?detailsProduct.nutritionFact.totalFat:"0mg"}
                                    </div>
                                    <div class="font-bold">10%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div>Saturated Fat 1g</div>
                                    <div class="font-bold">5%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div>
                                    <span class="italic">Trans Fat</span>{": "} {detailsProduct.nutritionFact?detailsProduct.nutritionFact.totalFat:"0mg"}
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div>
                                        <span class="font-bold">Cholesterol</span>{": "} {detailsProduct.nutritionFact?detailsProduct.nutritionFact.cholesterol:"0mg"}
                                    </div>
                                    <div class="font-bold">0%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div>
                                        <span class="font-bold">Sodium</span>{": "}{detailsProduct.nutritionFact?detailsProduct.nutritionFact.sodium:"0mg"}
                                    </div>
                                    <div class="font-bold">7%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div>
                                        <span class="font-bold">Total Carbohydrate</span>{": "} {detailsProduct.nutritionFact?detailsProduct.nutritionFact.totalCarbohydrates:"0mg"}
                                    </div>
                                    <div class="font-bold">13%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div class="pl-4">
                                        Dietary Fiber{": "} {detailsProduct.nutritionFact?detailsProduct.nutritionFact.dietaryFiber:"0mg"}
                                    </div>
                                    <div class="font-bold">14%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="pl-4">
                                    Total Sugar{": "} {detailsProduct.nutritionFact?detailsProduct.nutritionFact.sugars:"0mg"}
                                    <div class="pl-4">
                                        <hr class="border-gray-500"/>
                                        <div class="flex justify-between">
                                            <div>Includes 10g Added Sugars</div>
                                            <div class="font-bold">20%</div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div>
                                    <span class="font-bold">Protein</span>{": "} {detailsProduct.nutritionFact?detailsProduct.nutritionFact.protein:"0mg"}
                                </div>
                            </div>
                            <div class="border-t-8 border-black pt-1 text-sm">
                                <div class="flex justify-between">
                                    <div>Vitamin D 2mcg</div>
                                    <div>10%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div>Calcium {": "}{detailsProduct.nutritionFact?detailsProduct.nutritionFact.calcium:"0mg"}</div>
                                    <div>20%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div>Iron {": "}{detailsProduct.nutritionFact?detailsProduct.nutritionFact.iron:"0mg"}</div>
                                    <div>45%</div>
                                </div>
                                <hr class="border-gray-500"/>
                                <div class="flex justify-between">
                                    <div>Potassium {": "}{detailsProduct.nutritionFact?detailsProduct.nutritionFact.potassium:"0mg"}</div>
                                    <div>6%</div>
                                </div>
                                <div class="border-t-4 border-black flex leading-none text-xs pt-2 pb-1">
                                    <div class="pr-1">*</div>
                                    <div>The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.</div>
                                </div>
                            </div>
                        </div>
                    </div>

    let content

    if (isLoading) content = <p>Loading...</p>

    if (isError) {
        // content = <p className="errmsg">{error?.data?.message}</p>
        content = <div style={{ color: "red" }}>Loading...</div>
    }


   useEffect(() => {
    setDetailsProductImage(detailsProduct.urls)
        },[detailsProduct]);

    const isMobile = window.innerWidth < 768;


    const productDetailsContent=(
        <>
        <section class="lg:py-10 py-6">
            <div class="container flex justify-end md:gap-2 mx-2 pr-2 md:mx-0">
              
                <div class="grid items-center mx-4 md:mx-0  lg:grid-cols-2 gap-6">
                    <div class="grid grid-cols-1">

                    {/* hisi is he added kartt     */}

                        <div class="grid gap-4">
                            <div onClick={isMobile ? ()=>setOpenDetails(false) : undefined}>
                                {!openIngrident?
                                <img class="w-full aspect-video object-cover overflow-hidden group-hover:scale-105 transition-all" src={`${detailsProduct.urls ? detailsProductImage : detailsProduct.fPicName}`} alt=""/>
                                    :
                                <div >
                                    {nutriionFactConmponent}
                                </div>
                                }
                            </div>

                            
                            <div class="grid grid-cols-5 gap-1">                                
                                { detailsProduct.urls?
                                    detailsProduct.urls.map((val,idx)=>(
                                        <div class="cursor-pointer bg-gray-400">
                                            <img src={`${val}`} onClick={()=>{ setOpenIngrident(false);setDetailsProductImage(val)}} class="object-center h-16 md:h-20 max-w-full rounded-lg cursor-pointer w-full aspect-video object-cover overflow-hidden group-hover:scale-105 transition-all" />                                        
                                        </div>
                                        )):
                                        <div class="cursor-pointer">
                                            <img src={`${ detailsProduct.fPicName}`} class="object-cover object-center h-16 md:h-20 max-w-full rounded-lg cursor-pointer" />
                                        </div>                            
                                } 
                                <div onClick={()=>setOpenIngrident(true)} className="card bg-base-100 card-xs shadow-sm object-cover object-center h-16 md:h-20 max-w-full rounded-lg cursor-pointer">
                                    <div className="card-body">
                                        {/* <h2 className="card-title">Xsmall Card</h2> */}
                                        <p className='w-full object-cover'>
                                            <img src={nutritionFact} alt="NutritionFact" class="object-center h-16 md:h-20 max-w-full rounded-lg cursor-pointer w-full aspect-video object-cover overflow-hidden group-hover:scale-105 transition-all"  />;
                                         </p>
                                    </div>
                                </div>
                               <div onClick={()=>setOpenIngrident(true)} className="card bg-base-100 card-xs shadow-sm object-cover object-center h-16 md:h-20 max-w-full rounded-lg cursor-pointer">
                                    <div className="card-body">
                                        {/* <h2 className="card-title">Xsmall Card</h2> */}
                                        <p className='w-full object-cover'>
                                            <img src={nutritionFact} alt="NutritionFact" class="object-center h-16 md:h-20 max-w-full rounded-lg cursor-pointer w-full aspect-video object-cover overflow-hidden group-hover:scale-105 transition-all"  />;
                                         </p>
                                    </div>
                                </div>


                                {/* <div>
                                    <img class="h-auto max-w-full rounded-base" src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-1.jpg" alt=""/>
                                </div>


                                <div>
                                    <img class="h-auto max-w-full rounded-base" src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-2.jpg" alt=""/>
                                </div>
                                <div>
                                    <img class="h-auto max-w-full rounded-base" src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-3.jpg" alt=""/>
                                </div>
                                <div>
                                    <img class="h-auto max-w-full rounded-base" src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-4.jpg" alt=""/>
                                </div>
                                <div>
                                    <img class="h-auto max-w-full rounded-base" src="https://flowbite.s3.amazonaws.com/docs/gallery/square/image-5.jpg" alt=""/>
                                </div> */}
                            </div>
                        </div>


                                {/* this is the end of added  */}



                        {/* <div className=' bg-green-300'>
                            <div class="">
                                <div class="">
                                    {console.log("the product", detailsProductImage)}
                                    <div class="h-1/2 w-full" role="group" aria-label="1 / 3" >
                                        <img src={`${detailsProduct.urls ? detailsProductImage : detailsProduct.fPicName}`} alt="Product"  class="w-full aspect-video object-cover overflow-hidden group-hover:scale-105 transition-all"/>
                                    </div>

                                </div>
                            <span class="" aria-live="assertive" aria-atomic="true"></span></div>
                        </div> */}

                        {/* <div class="justify-center mt-2 ">
                            <div class="flex justify-start gap-2 w-full" style={{transform:"translate3d(0px, 0px, 0px)"}}>
                                
                            { detailsProduct.urls?
                                detailsProduct.urls.map((val,idx)=>(
                                    <div class="cursor-pointer " role="group" aria-label="1 / 3" style={{width: "60px", marginRight: "10px"}}>
                                        <img src={`${val}`} onClick={()=>setDetailsProductImage(val)} class="w-full h-full rounded"/>                                        
                                    </div>
                                    )):
                                    <div class="cursor-pointer" role="group" aria-label="1 / 3" style={{width: "60px", marginRight: "10px"}}>
                                        <img src={`${ detailsProduct.fPicName}`} class="w-full h-full rounded"/>
                                    </div>                            
                                } 
                        </div>
                        <span class="" aria-live="assertive" aria-atomic="true"></span>
                        </div> */}
                    
                    </div>

                    <div>
                        <h3 class="text-md md:text-lg font-medium text-default-800 mb-1">{detailsProduct.title}</h3>
                        {/* <h5 class="text-lg font-medium text-default-600 mb-2"><span class="text-base font-normal text-default-500">by</span> Blaze Pizza</h5> */}

                        <div class="flex items-center gap-3 mb-3">
                            <div class="flex gap-1.5">
                                <span><i class="iconify fa7-solid--star text-base text-yellow-400"></i></span>
                                <span><i class="iconify fa7-solid--star text-base text-yellow-400"></i></span>
                                <span><i class="iconify fa7-solid--star text-base text-yellow-400"></i></span>
                                <span><i class="iconify fa7-solid--star text-base text-yellow-400"></i></span>
                                <span><i class="iconify fa7-solid--star-half-stroke text-base text-yellow-400"></i></span>
                            </div>
                            <div class="h-4 w-px bg-default-400"></div>
                            {/* <h5 class="text-sm text-default-500">54 Reviews</h5> */}
                        </div>

                        <p class="text-sm text-default-500 mb-4">
                            {/* {detailsProduct} */}
                            {detailsProduct.text}
                            {/* Mexican burritos are usually made with a wheat tortilla and contain grilled meat, cheese toppings, and fresh vegetables which are sources of vitamins, proteins, fibers, minerals, and antioxidants.
                            This makes burritos a balanced meal that can be enjoyed in moderation as part of a healthy meal plan. */}
                            </p>

                        {/* <div class="flex gap-2 mb-5">
                            <div class="border border-default-200 rounded-full px-3 py-1.5 flex items-center gap-2.5">
                                <img src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20fill='%23D40000'%3e%3cpath%20d='M19%205V19H5V5H19M19%203H5C3.9%203%203%203.9%203%205V19C3%2020.11%203.9%2021%205%2021H19C20.11%2021%2021%2020.11%2021%2019V5C21%203.9%2020.11%203%2019%203M12%208C9.79%208%208%209.79%208%2012S9.79%2016%2012%2016%2016%2014.21%2016%2012%2014.21%208%2012%208Z'%20/%3e%3c/svg%3e" class="w-4 h-4"/>
                                <span class="text-xs">Non Vegetable</span>
                            </div>

                            <div class="border border-default-200 rounded-full px-3 py-1.5 flex items-center">
                                <span class="text-xs">Mexican</span>
                            </div>

                            <div class="border border-default-200 rounded-full px-3 py-1.5 flex items-center">
                                <span class="text-xs">Breakfast</span>
                            </div>
                        </div> */}

                        <div class="flex items-center gap-3 mb-8">
                            <h4 class="text-sm text-default-700">Size :</h4>{""} {detailsProduct.size}

                            {/* <div>
                                <input type="radio" name="option" id="1" value="1" class="peer hidden"
                                    // checked={detailsProduct.Size ==="S"?true:false}
                                    // checked={detailsProduct.Size ==="S"? true:false}
                                    // disabled={!detailsProduct.size==="S"? true:false}                                
                                />
                               { console.log(detailsProduct.size)}
                                <label for="1" class={`w-9 h-9 flex justify-center items-center cursor-pointer select-none rounded-full text-sm text-center bg-default-200 ${detailsProduct.Size ==="S"?"bg-primary text-white":""}`}>S</label>
                            </div>

                            <div>
                                <input type="radio" name="option" id="2" value="2" class="peer hidden"
                                    // checked={detailsProduct.Size ==="M"? true:false}
                                    // disabled={!detailsProduct.size==="M"? true:false}
                                 />
                                <label for="2" class={`w-9 h-9 flex justify-center items-center cursor-pointer select-none rounded-full text-sm text-center bg-default-200 ${detailsProduct.Size ==="M"? " bgred text-white":""}`}>M</label>
                            </div>

                            <div>
                                <input type="radio" name="option" id="3" value="3" class="peer hidden"
                                    // checked={detailsProduct.size ==="L"? true:false}
                                    // disabled={!detailsProduct.size==="L"? true:false}
                                 />
                                <label for="3" class={`w-9 h-9 flex justify-center items-center cursor-pointer select-none rounded-full text-sm text-center bg-default-200 ${detailsProduct.Size ==="L"? "bg-primary text-white":""}`}>L</label>
                            </div> */}
                        </div>

                        {/* <div class="flex items-center gap-2 mb-8"> */}
                            {/* <div class="relative z-10 inline-flex justify-between border border-default-200 p-1 rounded-full">
                                <button type="button" class="minus flex-shrink-0 bg-default-200 text-default-800 rounded-full h-9 w-9 text-sm inline-flex items-center justify-center" fdprocessedid="zbtzec">–</button>
                                <input type="text" class="w-12 border-0 text-sm text-center focus:ring-0 p-0 bg-transparent" value="1" min="0" max="100" readonly="" fdprocessedid="1i6zvt"/>
                                <button type="button" class="plus flex-shrink-0 bg-default-200 text-default-800 rounded-full h-9 w-9 text-sm inline-flex items-center justify-center" fdprocessedid="38q1ae">+</button>
                            </div> */}  

                            {/* <a href="cart.html" class="inline-flex items-center justify-center rounded-sm border border-primary bg-primary px-10 py-3 text-center text-sm font-medium text-white shadow-sm transition-all duration-500 hover:bg-primary-500">
                                Buy Now
                            </a> */}

                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="heart" class="lucide lucide-heart h-8 w-8 text-default-400 cursor-pointer hover:fill-red-600 hover:text-red-600 focus:fill-red-600 focus:text-red-600"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path></svg> */}
                        {/* </div> */}

                        <div class="mb-6">
                            <h4 class=" text-sm lg:text-lg font-medium text-default-700 mb-4">Nutrition Facts <span class="text-sm text-default-400">(per serving)</span></h4>

                            <div class="border border-default-200 p-3 rounded-none md:rounded-lg">
                                <div class="grid grid-cols-4 justify-center">
                                    <div class="text-center text-sm">
                                        <h4 class="text-sm text-default-700 mb-1">{detailsProduct.nutritionFact?detailsProduct.nutritionFact.calories:"0g"}</h4>
                                        <h4 class="text-sm text-default-700">Calories</h4>
                                    </div>

                                    <div class="text-center">
                                        <h4 class="text-sm md:font-medium text-default-700 mb-1">{detailsProduct.nutritionFact?detailsProduct.nutritionFact.totalFat:"0g"}</h4>
                                        <h4 class="text-sm text-default-700">Fat</h4>
                                    </div>

                                    <div class="text-center">
                                        <h4 class="text-sm md:font-medium text-default-700 mb-1">{detailsProduct.nutritionFact?detailsProduct.nutritionFact.dietaryFiber:"0g"}</h4>
                                        <h4 class="text-sm text-default-700">Carbs</h4>
                                    </div>

                                    <div class="text-center">
                                        <h4 class="text-sm md:font-medium text-default-700 mb-1">{detailsProduct.nutritionFact?detailsProduct.nutritionFact.protein:"0g"}</h4>
                                        <h4 class="text-sm text-default-700">Protein</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="eye" class="lucide lucide-eye w-5 h-5 me-2 text-primary"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
                            <h5 class="text-sm text-default-600"><span class="text-primary font-semibold">---</span>&nbsp; People are viewed this month</h5>
                        </div>
                    </div>
                </div>
                {/* <!-- end grid --> */}
                  <div className='cursor-pointer hidden md:block'>
                    <svg onClick={()=>setOpenDetails(false)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </div>
            </div>
        {/* <!-- end container --> */}
        </section>
        </>
    )
    if (isSuccess) {
        const { ids } = notes

        const dataResponse = ids.map((val) => {
            return notes.entities[val]
        })

        var myData = Object.keys(dataResponse).map(key => {
            return dataResponse[key];
        })
        
        content = (
            <div className='my-10 grid gap-2 grid-cols-12'>
                <div className='hidden md:block md:col-span-3'>
                    <div className='ml-8 mt-0'>
                        <p className=' mb-16'><Link to="/" className=' cursor-pointer'>Home</Link> {'>'}
                            {selectedFiler === "" ? "All Products" : selectedFiler}</p>
                        <h1 className=' text-[18px] font-Oswald font-black my-2'>Browse by</h1>
                        <hr className=' w-3/4 h-[2px] bg-gray-400' />
                        <span>
                            {leftShoppingLink.map((links) => (
                                <p key={links.id} onClick={() => setSelectedFiler(links.links)} className=' my-4 cursor-pointer'>
                                    {links.links}
                                </p>
                            ))}
                        </span>
                        <h2 className=' mt-10 font-Oswald font-black text-[18px'>Filter by</h2>
                        <hr className=' w-3/4 h-[2px] bg-gray-400 my-6' />
                        <p>Price</p>

                        <div className="relative w-3/4 mb-6">
                            <label htmlFor="labels-range-input" className="sr-only">Labels range</label>
                            <input id="labels-range-input" type="range" value="1000" min="100" max="1500" className="w-full h-[2px] bg-gray-400 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                            <span className="text-sm text-gray-500 dark:text-gray-400 absolute start-0 -bottom-6">$1.99</span>
                            <span className="text-sm text-gray-500 dark:text-gray-400 absolute end-0 -bottom-6">$15.99</span>

                        </div>

                        <hr className='w-3/4 h-[2px] bg-gray-0 my-6' />
                        <hr className='w-3/4 h-[2px] bg-gray-400 my-4' />
                        <span className='w-3/4 left-0 flex-col'>
                            <span className=' w-3/4 left-0 flex justify-between'>
                                <p>Color</p>
                                <p onClick={() => setIsColor(!isColor)} className=' cursor-pointer text-[18px] font-Avenir' >
                                    {!isColor ? '+' : '-'}
                                </p>
                            </span>
                            {
                                isColor &&
                                <div className='my-4 w-3/4 left-0'>
                                    <ul className="flex flex-row justify-center items-center">
                                        <li className="mr-4 last:mr-0">
                                            <span
                                                className="block p-1 border-2 border-gray-500 rounded-full transition ease-in duration-300">
                                                <a href="#blue" className="block w-6 h-6 bg-blue-900 rounded-full"></a>
                                            </span>
                                        </li>
                                        <li className="mr-4 last:mr-0">
                                            <span
                                                className="block p-1 border-2 border-white hover:border-gray-500 rounded-full transition ease-in duration-300">
                                                <a href="#yellow" className="block w-6 h-6 bg-yellow-500 rounded-full"></a>
                                            </span>
                                        </li>
                                        <li className="mr-4 last:mr-0">
                                            <span
                                                className="block p-1 border-2 border-white hover:border-gray-500 rounded-full transition ease-in duration-300">
                                                <a href="#red" className="block w-6 h-6 bg-red-500 rounded-full"></a>
                                            </span>
                                        </li>
                                        <li className="mr-4 last:mr-0">
                                            <span
                                                className="block p-1 border-2 border-white hover:border-gray-500 rounded-full transition ease-in duration-300">
                                                <a href="#green" className="block w-6 h-6 bg-green-500 rounded-full"></a>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            }


                        </span>

                        <hr className=' w-3/4 h-[2px] bg-gray-400 my-2' />

                        <span className='w-3/4 left-0 flex-col'>
                            <span className=' w-3/4 left-0 flex justify-between'>
                                <p>Size</p>
                                <p onClick={() => setIsSize(!isSize)} className=' cursor-pointer'>
                                    {!isSize ? '+' : '-'}
                                </p>
                            </span>

                            {
                                isSize &&

                                <ul className="w-48 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">

                                    {['500ml', '250ml', '80ml', 'Large', 'Medium', 'Small'].map((val, index) => (


                                        <li className="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600" key={index}>
                                            <div className="flex items-center ps-3">
                                                <input id="vue-checkbox" type="checkbox" value="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                <label htmlFor="vue-checkbox" className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">{val}</label>
                                            </div>
                                        </li>

                                    ))}
                                </ul>
                            }
                        </span>
                        <hr className=' w-3/4 h-[2px] bg-gray-400 my-2' />
                    </div>
                </div>
               
                <div className=' col-span-12 md:col-span-9'>
                {/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++    */}
                    {openDetails &&<div>{productDetailsContent}</div>}

                {/* +++++++++++++++++++++++++++++++++++++++ */}

                {!openDetails &&<>
                    <h1 className=' font-Oswald text-[26px] text-center lg:text-start mx-auto justify-between lg:mx-0 lg:justify-start mt-16'>All Products</h1>
                    <p className=' w-full md:pr-8 py-8 text-center lg:text-start mx-auto justify-between lg:mx-0 lg:justify-start'>
                        For centuries, spices have been one of the most essential ingredients in kitchens - they add flavor and aroma, enhance the taste of food, and even boost the colors in popular dishes.
Ethiopian cuisine is defined by bold, aromatic spice blends and indigenous ingredients, featuring staples like fiery berbere and mitmita. These mixtures, alongside unique spices like korarima (Ethiopian cardamom), besobila (holy basil), and timiz (long pepper), create complex, smoky, and earthy flavors crucial to stews (wots) and culinary traditions. If you are looking for a little direction when it comes to spicing up your cuisine, our mart is the best place where you can find authentic Ethiopian spices and goods imported directly from Ethiopia.
                                                       </p></>
                    }
                    <span className=' mx-auto flex justify-between px-6 md:px-0'>
                        <p>{ids?.length}&nbsp; products</p>
                        <span className='hidden md:block'>Sort by:
                            <select>
                                {
                                    ['Recomended', 'Newest', 'Price(Low to High)', 'Price(High to Low)', 'Name A-Z', 'Name Z-A'].map((val, index) => (
                                        <option key={index}>{val}</option>
                                    ))
                                }
                            </select>
                        </span>
                        {!isFilter &&
                            <span className='block md:hidden underline font-Avenir text-[16px] hover:cursor-pointer'
                                onClick={() => setIsFilter(!isFilter)}
                            >
                                Filter & Sort
                            </span>
                        }
                    </span>
                    {isFilter &&

                        <div className={`absolute top-0 left-0 md:hidden h-[100vh] z-10  w-full bg-white flex flex-col gap-6 transform transition-transform ${isFilter ? "opacity-96" : "opacity-0"}`}
                            style={{ transition: "transform 0.3s ease, opacity 0.3s ease" }}
                        >
                            <span className=' isolate flex items-center'>
                                <p className='text-left font-Oswald text-[20px]'>Filter & Sort</p>
                                <p className=' text-[14px] font-Avenir'>&nbsp;(&nbsp;{AllProducts.length}&nbsp; products&nbsp;)</p>
                            </span>

                            <span className=' mx-auto flex justify-between px-6 md:px-0'>

                                {!isFilter &&
                                    <span className='block md:hidden underline font-Avenir text-[16px] hover:cursor-pointer'
                                        onClick={() => setIsFilter(!isFilter)}
                                    >
                                        Filter & Sort
                                    </span>

                                }
                            </span>

                            <div className=" absolute top-0 right-0 flex flex-1 justify-end items-center">
                                <img
                                    src={close}
                                    alt="menu"
                                    className="w-[18px] h-[18px] mx-4 my-4 object-contain cursor-pointer text-black"
                                    onClick={() => setIsFilter(!isFilter)}
                                />
                            </div>

                            {/* <hr className=' isolate w-full h-[1px] bg-gray-400' /> */}

                            {/* __________________________________________________additional part */}


                            <hr className='w-[95%] h-[2px] bg-gray-500' />


                            <span className='w-[95%] left-0 flex-col'>
                                <span className=' w-full left-0 flex items-center justify-between'>
                                    <p>Sort by:</p>
                                    <p onClick={() => setisMiniSortBy(!isMiniSortBy)} className='cursor-pointer text-[18px] font-Avenir'>
                                        {!isMiniSortBy ?
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                            </svg>

                                            :
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
                                            </svg>


                                        }
                                    </p>
                                </span>

                                {
                                    isMiniSortBy &&

                                    <ul className="w-48 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">

                                        {['Recomended', 'Newest', 'Price (low to high)', 'Price (high to low)', 'Name A-Z', 'Name Z-A'].map((val, index) => (

                                            <li className="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600" key={index}>
                                                <div className="flex items-center ps-3">
                                                    <input id="vue-checkbox" type="checkbox" value="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                    <label htmlFor="vue-checkbox" className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">{val}</label>
                                                </div>
                                            </li>


                                        ))}
                                    </ul>

                                }

                            </span>

                            <hr className=' w-[95%] h-[2px] bg-gray-400' />

                            <span className='w-[95%] left-0 flex-col'>
                                <span className=' w-full left-0 flex items-center justify-between'>
                                    <p>Color</p>
                                    <p onClick={() => setIsMiniColor(!isMiniColor)} className=' cursor-pointer' >
                                        {!isMiniColor ?

                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                            </svg>

                                            :
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
                                            </svg>

                                        }
                                    </p>
                                </span>
                                {
                                    isMiniColor &&
                                    <div className='my-4 w-3/4 left-0'>
                                        <ul className="flex flex-row justify-center items-center">
                                            <li className="mr-4 last:mr-0">
                                                <span
                                                    className="block p-1 border-2 border-gray-500 rounded-full transition ease-in duration-300">
                                                    <a href="#blue" className="block w-6 h-6 bg-blue-900 rounded-full"></a>
                                                </span>
                                            </li>
                                            <li className="mr-4 last:mr-0">
                                                <span
                                                    className="block p-1 border-2 border-white hover:border-gray-500 rounded-full transition ease-in duration-300">
                                                    <a href="#yellow" className="block w-6 h-6 bg-yellow-500 rounded-full"></a>
                                                </span>
                                            </li>
                                            <li className="mr-4 last:mr-0">
                                                <span
                                                    className="block p-1 border-2 border-white hover:border-gray-500 rounded-full transition ease-in duration-300">
                                                    <a href="#red" className="block w-6 h-6 bg-red-500 rounded-full"></a>
                                                </span>
                                            </li>
                                            <li className="mr-4 last:mr-0">
                                                <span
                                                    className="block p-1 border-2 border-white hover:border-gray-500 rounded-full transition ease-in duration-300">
                                                    <a href="#green" className="block w-6 h-6 bg-green-500 rounded-full"></a>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                }


                            </span>


                            <hr className=' w-[95%] h-[2px] bg-gray-400' />


                            <span className='w-[95%] left-0 flex-col'>
                                <span className=' w-full left-0 flex items-center justify-between'>
                                    <p>Size</p>
                                    <p onClick={() => setIsMiniSize(!isMiniSize)} className='cursor-pointer text-[18px] font-Avenir'>
                                        {!isMiniSize ?

                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                            </svg>

                                            :
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
                                            </svg>
                                        }
                                    </p>
                                </span>

                                {
                                    isMiniSize &&

                                    <ul className="w-48 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">

                                        {['500ml', '250ml', '80ml', 'Large', 'Medium', 'Small'].map((val, index) => (


                                            <li className="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600" key={index}>
                                                <div className="flex items-center ps-3">
                                                    <input id="vue-checkbox" type="checkbox" value="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                                    <label htmlFor="vue-checkbox" className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">{val}</label>
                                                </div>
                                            </li>


                                        ))}
                                    </ul>


                                }

                            </span>
                            {/* _____________________________________________________end additional part */}

                        </div>
                    }
                       

                    {/* <div className='text-center bg-white grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'> */}

                        {/* <div className='mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4'>  */}
                        
                        <div className='bg-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5  gap-5'>
                         {/* <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3'> */}
                        
                        {/* <div class="grid xl:grid-cols-3 sm:grid-cols-2 gap-5"> */}
                        {
                            myData.map((product, index) => (
                                ((
                                    selectedFiler === "liquour" ? ['liquour'].includes(product.fType) :
                                        selectedFiler === "spices" ? ['spices'].includes(product.fType) :
                                            selectedFiler === "cloths" ? ['cloths'].includes(product.fType) :
                                                selectedFiler === "others" ? ['others'].includes(product.fType) :
                                                    selectedFiler === "grocery" ? ['grocery'].includes(product.fType) :
                                                        ['liquour', 'spices', 'cloths', 'others', 'grocery'].includes(product.fType)
                                ) && product.completed) &&
                                < div className="container mx-auto justify-between block md:grid md:grid-cols-2 md:gap-3 lg:grid lg:grid-cols-3 lg:gap-5" key={index} onClick={()=>setDetailsProduct(product)} >
                                    <ShoppingCard key={product.id} {...product} openDetails={openDetails} setOpenDetails={setOpenDetails} />
                                </div>
                            ))}
                    </div>


                </div>

            </div >
        )
    }
    return content
}

export default ShopOnline
